import { render, staticRenderFns } from "./printJSTrans.vue?vue&type=template&id=2ee3226c&scoped=true&"
import script from "./printJSTrans.vue?vue&type=script&lang=js&"
export * from "./printJSTrans.vue?vue&type=script&lang=js&"
import style0 from "./printJSTrans.vue?vue&type=style&index=0&lang=less&"
import style1 from "./printJSTrans.vue?vue&type=style&index=1&id=2ee3226c&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3226c",
  null
  
)

component.options.__file = "printJSTrans.vue"
export default component.exports